export enum CurrencySymbols {
  EUR = '€',
  GBP = '£',
}
